import React, { useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { Select } from 'antd';
import Api from "../../services/api";
import { UploadFileDragger } from "../../components/Core";
import { success_message, error_message } from "../../components/Toastr";
import { ContentModal } from "../List/ConfigNode/styles";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const FormImportTasks = _ref => {
    let { formId } = _ref;
    const { t } = useTranslation();
    const [showLogs, setShowLogs] = useState(false);
    const [selectedFormId, setSelectedFormId] = useState(formId);
    const [loadingForms, setLoadingForms] = useState(false);
    const [formOptions, setFormOptions] = useState([]);
    const containerLogMessages = useRef(null);
    // Carrega lista de formulários
    React.useEffect(() => {
        if (!formId) {
            setLoadingForms(true);
            Api.post('/Form/getAllSelectBase', {
                ImportarTarefas: true
            }).then(response => {
                const options = response.data.response.map(i => ({
                    label: i.name,
                    value: i.baseId
                }));
                setFormOptions(options);
                setLoadingForms(false);
            }).catch(error => {
                console.error('Error loading forms:', error);
                setLoadingForms(false);
            });
        }
    }, [formId]);
    const handleUpload = options => {
        if (options.file instanceof File) {
            setShowLogs(false);
            const formData = new FormData();
            // O endpoint espera um objeto FileUploadRequest com a propriedade Files (array)
            formData.append("Files", options.file);
            Api.post(`/FormTask/importTasksFromExcel`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (options.onSuccess)
                    options.onSuccess(r.data, r.request);
                success_message(t("Prompt.AsyncSent"));
                // Mostra informações sobre o processamento assíncrono
                if (containerLogMessages.current) {
                    containerLogMessages.current.innerText = `${t('Import.Processing') || 'Processamento iniciado'}:\n` + `${t('Import.AsyncProcess') || 'O arquivo está sendo processado de forma assíncrona.'}\n` + `${t('Import.CheckResults') || 'Verifique os resultados na lista de processos assíncronos.'}\n\n` + (r.data?.response?.id ? `Task ID: ${r.data.response.id}` : '');
                }
                setShowLogs(true);
            }).catch(err => {
                if (options.onError)
                    options.onError(err);
                console.error(err);
                const errorMsg = err.response?.data?.message || err.message || t("Prompt.Upload.Error");
                error_message(errorMsg);
                setShowLogs(true);
                if (containerLogMessages.current) {
                    containerLogMessages.current.innerText = `Error: ${errorMsg}`;
                }
            });
        }
    };
    const preStyle = {
        overflow: "auto",
        maxHeight: "400px"
    };
    async function downloadTemplate() {
        if (!selectedFormId) {
            error_message(t("History.PleaseSelectForm"));
            return;
        }
        try {
            const response = await Api.get(`/FormTask/downloadTaskImportTemplate?formId=${selectedFormId}`, {
                responseType: 'blob'
            });
            // Cria um link para download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `TaskImportTemplate_${selectedFormId}_${new Date().toISOString().split('T')[0]}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            success_message(t("History.TemplateDownloaded"));
        }
        catch (err) {
            console.error(err);
            const errorMsg = err.response?.data?.message || err.message || t("History.TemplateDownloadError");
            error_message(errorMsg);
        }
    }
    return /*#__PURE__*/ _jsxs(ContentModal, {
        children: [!formId && /*#__PURE__*/ _jsxs("div", {
                style: {
                    marginBottom: 15
                },
                children: [/*#__PURE__*/ _jsxs("label", {
                        style: {
                            display: 'block',
                            marginBottom: 5,
                            fontWeight: 'bold'
                        },
                        children: [t("Comp.Form"), " ", /*#__PURE__*/ _jsxs("span", {
                                style: {
                                    fontWeight: 'normal',
                                    fontSize: '12px',
                                    color: '#666'
                                },
                                children: ["(", t("History.RequiredForTemplate"), ")"]
                            }), ":"]
                    }), /*#__PURE__*/ _jsx(Select, {
                        style: {
                            width: '100%'
                        },
                        placeholder: t("History.SelectForm"),
                        loading: loadingForms,
                        showSearch: true,
                        filterOption: (input, option) => {
                            const searchText = input.toLowerCase();
                            const formName = (option?.label || '').toLowerCase();
                            // Verifica se qualquer palavra do nome do formulário contém o texto de busca
                            return formName.split(/\s+/).some(word => word.includes(searchText));
                        },
                        value: selectedFormId,
                        onChange: value => setSelectedFormId(value),
                        options: formOptions
                    })]
            }), /*#__PURE__*/ _jsx("a", {
                style: {
                    display: "block",
                    marginTop: 15,
                    marginBottom: 15,
                    cursor: "pointer"
                },
                onClick: () => downloadTemplate(),
                children: t("Tree.Import.Form.TemplateLink")
            }), /*#__PURE__*/ _jsx(UploadFileDragger, {
                accept: ".xlsx,.xls",
                customRequest: handleUpload,
                children: t("SelectExcelFile")
            }), /*#__PURE__*/ _jsx("div", {
                style: {
                    display: showLogs ? "block" : "none",
                    marginTop: 30
                },
                children: /*#__PURE__*/ _jsx("pre", {
                    style: preStyle,
                    ref: containerLogMessages
                })
            })]
    });
};
